import template from './account.html';

class AccountViewModel
{
	constructor(page)
	{
		this.page = page;
		this.tabs = ko.observableArray([{
			route: '/account/acc-overview',
			page_id: '[/account/]acc-overview',
			title: 'Overview',
			icon: ''
		}, {
			route: '/account/acc-info',
			page_id: '[/account/]acc-info',
			title: 'Info',
			icon: ''
		}, {
			route: '/account/acc-advanced-settings',
			page_id: '[/account/]acc-advanced-settings',
			title: 'Advanced Settings',
			icon: ''
		}]); 
		this.UserAccountDialogs = ko.observableArray(window.UserAccountDialogs || []);
		this.UserAccountPages = ko.observableArray(window.UserAccountPages || []);
		this.data = ko.observable();
		this.current_page_id = ko.observable();
		this.profile_photo = ko.observable();
		this.upload_photo = ko.observable();
		this.username = ko.observable();
	}

	load_tab (page_id)
	{
		window.localStorage.setItem('last_account_page', page_id);
		const element = this.page.element.querySelector('#page_content');
		this.current_page_id(page_id);
		const page = Grape.pages.find_page_by_id(page_id);

		if (!page)
			throw new Error(`Page with id "${page_id}" not found`);

		Grape.pages.load_page(page, element, { data: this.data() }, {}, () => {});
	}

	async upload_profile_photo () 
	{
		$('#image_upload').trigger('click');
	}
}

class AccountViewPage
{
	constructor(bindings, element)
	{
		this.viewModel = new AccountViewModel(this);
		this.bindings = bindings;
		this.element = element;
	}
	
	async init ()
	{
		document.title = 'Stock Item';
		await this.load();
		await this.loadProfilePhoto();

		if (window.localStorage.getItem('last_account_page'))
			this.viewModel.load_tab(window.localStorage.getItem('last_account_page'));
		else
			this.viewModel.load_tab('[/account/]acc-overview');

		// Register file upload event listener
		const hiddenFileInput = document.getElementById('image_upload');
		hiddenFileInput.addEventListener('change', async () => {
			const selectedFile = hiddenFileInput.files[0]; // Get the selected file

			if (selectedFile)
			{
				let header_info = { 
					"X-SessionID": localStorage.getItem('session_id'),
					"Accept": "application/json"
				};

				//SERVER: Upload file(s)
				try
				{
					let response = await fetch('/api/user/photo', {
						method: 'POST',
						body: new FormData(document.getElementById('image_upload_form')),
						headers: header_info
					});

					let data = await response.json();
					if (response.ok)
						Grape.alerts.alert({ type: 'success', title: 'Success', message: 'Profile Photo Successfully Uploaded'});
					else 
						throw new Error(data.message);
				} catch (exception) {
					Grape.alerts.alert({ type:'warning', message: exception, title:`File Upload Error` });
					console.error(exception);
				} finally {
					this.update_data();
				}
			}
		});
	}	
	
	async load ()
	{
		try {
			let result = await fetch('/api/user/-1');
			let data = await result.json();

			if (result.ok)
			{
				this.viewModel.data(data.user);
				this.viewModel.username(data.user.username)
			}
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error);
		}
	}

	async loadProfilePhoto ()
	{
		try
		{
			let result = await fetch(`/api/user/photo`, {
				method: 'GET',
				headers: { 'Content-Type': 'image/png' }
			});

			if (result.status == 200)
			{
				let blob = await result.blob()
				let img = document.getElementById('pfp');
				img.src = URL.createObjectURL(blob);
				this.viewModel.profile_photo(URL.createObjectURL(blob));
			} else if (result.status == 204)
				console.log('No user profile photo found');
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}
	}

	async update_data ()
	{
		try {
			await this.load();
			await this.loadProfilePhoto();
		} catch (err) { 
			console.error(err);
			Grape.alert_api_error(err);
		}
	}
}

export default {
	route: '[/]grape-ui/my-account',
	page_class: AccountViewPage,
	template: template
}
